import { BudgetYearLimitDetailComponent } from "../../../components/SupportSystem/Admin/BudgetYearLimitDetailComponent"
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
export function BudgetYearLimitDetailContainer () {
    const titleName = "แบบฟอร์มบันทึกข้อมูลผลการอนุมัติงบประมาณวงเงินช่วยเหลือหรืออุดหนุน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem  />
            <HeadTitle title={titleName} />
            <BudgetYearLimitDetailComponent/>
            <Footer />
        </div>   
    )
}